module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-latin-ext-400-normal.woff2?861b791f9de857a6e7bcf77612740c18";